import { render, staticRenderFns } from "./Verifier.vue?vue&type=template&id=bcbc01c4"
import script from "./Verifier.vue?vue&type=script&lang=js"
export * from "./Verifier.vue?vue&type=script&lang=js"
import style0 from "./Verifier.vue?vue&type=style&index=0&id=bcbc01c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports